// This avoids errors from a known issue with Facebook's webview, where the _AutofillCallbackHandler
// function is invoked without it being defined (https://developers.facebook.com/community/threads/320013549791141/)
window._AutofillCallbackHandler = window._AutofillCallbackHandler || function() {}
